import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';

import { BlueCloseIcon, BlueTickIcon } from '../../../../images/icons/WrapSvg';

class TabAdd extends React.Component {
    state = {
        name: this.props.name !== undefined ? this.props.name : '',
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ name: nextProps.name !== undefined ? nextProps.name : '' });
    }

    handleChange = (name) => (event) => {
        this.setState({
            [name]: event.target.value,
        });
    };

    render() {
        const { open, onClose, intl, title } = this.props;
        const { name } = this.state;
        return (
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen
                className="z_index_dialog"
            >
                <div className={'flex_header'}>
                    <div className={'flex_full_row padding_borders shadow'}>
                        <BlueCloseIcon
                            color="primary"
                            onClick={this.props.onClose}
                            className="margin_right_18 hand"
                        />
                        <span className={'barlowsemicondensed_bold flex_full c_dark_grey_blue '}>
                            <FormattedMessage id={title} />
                        </span>
                        {name !== undefined && name.length > 3 ? (
                            <BlueTickIcon
                                className="hand"
                                color="primary"
                                onClick={this.props.add(name)}
                            />
                        ) : (
                            <div />
                        )}
                    </div>
                </div>
                <DialogContent>
                    <div className="flex_full_column margin_top_9 padding_borders">
                        <TextField
                            autoFocus
                            id="name"
                            label={intl.formatMessage({ id: 'form_add_family_name' })}
                            className={'flex_full_row upper'}
                            value={name}
                            onChange={this.handleChange('name')}
                            margin="normal"
                        />
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

TabAdd.propTypes = {
    intl: intlShape.isRequired,
};

TabAdd = injectIntl(TabAdd);

export default TabAdd;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/FamilyAdd.js